<script setup>
import { Icon } from '@iconify/vue';
import { computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    subtitle: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    },
    color: {
        type: String,
        default: 'blue' // Options: blue, rose, green, purple, amber, slate, indigo
    },
    hideSubtitleOnMobile: {
        type: Boolean,
        default: false
    },
    actionsOnBottomOnMobile: {
        type: Boolean,
        default: true
    },
    hideIconOnMobile: {
        type: Boolean,
        default: false
    }
});

// Tailwind requiere clases completas para el compilador (JIT), usamos un mapa en lugar de clases dinámicas.
const colorMap = {
    blue: 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
    rose: 'bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400',
    green: 'bg-green-50 dark:bg-green-900/30 text-green-600 dark:text-green-400',
    purple: 'bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400',
    amber: 'bg-amber-50 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400',
    slate: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400',
    indigo: 'bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400'
};

const iconClass = computed(() => colorMap[props.color] || colorMap.blue);
</script>

<!-- hideSubtitleOnMobile: Ocultara el subtitulo en movil -->
<!-- actionsOnBottomOnMobile: mostrara los botones a la derecha -->

<template>
    <div class="flex flex-col justify-center gap-4 min-h-[60px] sm:min-h-[48px]">
        <!-- Main Row: Icon, Title & Actions -->
        <div :class="[actionsOnBottomOnMobile ? 'flex-col' : 'flex-row items-center justify-between', 'flex sm:flex-row sm:items-center sm:justify-between gap-4']">
            
            <!-- Left Side: Icon, Title, Subtitle -->
            <div class="flex items-center gap-3">
                <!-- Box de ícono -->
                <div v-if="icon" class="p-2.5 rounded-2xl shadow-sm" :class="[iconClass, { 'hidden sm:block': hideIconOnMobile }]">
                    <Icon :icon="icon" class="w-7 h-7" />
                </div>
                
                <!-- Textos -->
                <div>
                    <h2 class="font-extrabold text-xl lg:text-2xl text-slate-800 dark:text-white leading-tight">
                        {{ title }}
                    </h2>
                    <p v-if="subtitle" class="text-xs text-slate-500 dark:text-slate-400 mt-1" :class="{ 'hidden sm:block': hideSubtitleOnMobile }">
                        {{ subtitle }}
                    </p>
                </div>
            </div>

            <!-- Right Side: Actions (Buttons, Dropdowns, etc) -->
            <div v-if="$slots.actions" class="flex flex-wrap items-center gap-2">
                <slot name="actions" />
            </div>
        </div>

        <!-- Bottom Content: Tabs, Filters, etc -->
        <div v-if="$slots.bottom" class="w-full">
            <slot name="bottom" />
        </div>
    </div>
</template>
